export default __webpack_public_path__ + "static/media/gd_2.2a12d3cb.jpg";